<template>
  <div
    v-if="filtros.length"
    class="resumen-filtros"
    v-tooltip.top-center="{ content: textoCompleto, html: false }"
  >
    <i class="fa fa-filter" aria-hidden="true"></i>
    <p class="resumen-filtros__texto">
      <span v-for="filtro in filtros" :key="filtro.key" class="resumen-filtros__item">
        <span class="resumen-filtros__etiqueta">{{ filtro.label }}:</span>
        <span class="resumen-filtros__valor">{{ filtro.value }}</span>
      </span>
    </p>
  </div>
</template>

<script>
import { prepararResumenFiltros } from "@/util/resumenFiltros";

export default {
  props: {
    filtrosProp: { type: Object, default: () => ({}) },
  },
  computed: {
    filtros() {
      return prepararResumenFiltros(this.filtrosProp);
    },
    textoCompleto() {
      return this.filtros.map((filtro) => `${filtro.label}: ${filtro.value}`).join(" · ");
    },
  },
};
</script>
